import { useCallback } from 'react'

import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import { RuleType } from '@cox/core-ui8/dist/types'

import ConditionalDefaultBlock from './ConditionalDefaultBlock'
import { isAuthor } from '../../../constants'
import RuleDetails from '../RuleBuilder/RuleDetails'
import RuleTypeRenderer from '../RuleBuilder/RuleTypeRenderer'
import ConditionalInversionBlock from './ConditionalInversionBlock/ConditionalInversionBlock'

const RuleBuilderConditional = (props: any) => {
  const {
    conditionals = [],
    id,
    isInEditor = false,
    editmode = false,
    index,
    resultsTrue,
    resultsFalse,
    ruleId,
    componentTypeRenderer
  } = props
  const isEditor = isInEditor || editmode || isAuthor()
  const defaultConditional = conditionals.find((condition: any) => condition.defaultblock)
  const filteredConditionals = conditionals.filter((condition: any) => !condition.defaultblock)
  const { appData } = useAppDataContext()
  const isLocal = appData?.page?.isLocal === 'true' ? true : false
  const getConditionals = useCallback(() => {
    if (isEditor) {
      return conditionals.map((condition: any, conditionIndex: number) => {
        const {
          ruleExpression,
          resultsTrue = {},
          ruleId,
          ruleType,
          ruleName,
          ruleDescription,
          trueExpFragmentPath,
          falseExpFragmentPath
        } = condition

        return (
          <div key={conditionIndex}>
            <RuleDetails
              isInEditor={isEditor}
              ruleId={ruleId}
              ruleType={ruleType}
              ruleName={ruleName}
              ruleDescription={ruleDescription}
              ruleExpression={ruleExpression}
              trueExpFragmentPath={trueExpFragmentPath}
              falseExpFragmentPath={falseExpFragmentPath}
            />
            <RuleTypeRenderer
              ruleId={ruleId}
              resultsTrue={resultsTrue}
              resultsFalse={resultsFalse}
              ruleType={ruleType}
              condition={condition}
              ruleExpression={ruleExpression}
              isInEditor={isEditor}
              componentTypeRenderer={componentTypeRenderer}
              compName={props?.compName}
            />
          </div>
        )
      })
    } else if (isLocal) {
      return (
        <ConditionalInversionBlock
          filteredConditionals={filteredConditionals}
          isEditor={isEditor}
          resultsFalse={resultsFalse}
          componentTypeRenderer={componentTypeRenderer}
          defaultConditional={defaultConditional}
        />
      )
    } else {
      let result
      for (const condition of filteredConditionals) {
        const { ruleExpression, resultsTrue = {}, ruleId, ruleType } = condition

        const getUdoResult = () => {
          if (typeof ruleExpression === 'string') {
            return (
              ruleType === RuleType.udoconditional &&
              ruleExpression &&
              !ruleExpression?.includes('udo') &&
              eval(ruleExpression)
            )
          }
          return ruleType === RuleType.udoconditional && ruleExpression && eval(ruleExpression)
        }
        const isWindowCondtional = ruleType === RuleType.conditional && ruleExpression && eval(ruleExpression)
        const isUdoConditional = getUdoResult()
        if (isWindowCondtional || isUdoConditional) {
          result = (
            <RuleTypeRenderer
              ruleId={ruleId}
              resultsTrue={resultsTrue}
              resultsFalse={resultsFalse}
              ruleType={ruleType}
              condition={condition}
              ruleExpression={ruleExpression}
              isInEditor={isEditor}
              componentTypeRenderer={componentTypeRenderer}
              compName={props?.compName}
            />
          )
          break
        }
      }
      return result ?? <ConditionalDefaultBlock isInEditor={isEditor} defaultConditional={defaultConditional} {...props} />
    }
  }, [conditionals, isInEditor, index])

  const getUdoElseBlock = () => {
    if (conditionals.length === 0 && (resultsTrue || resultsFalse)) {
      return (
        <RuleTypeRenderer
          key={index}
          ruleId={ruleId}
          resultsTrue={resultsTrue}
          resultsFalse={resultsFalse}
          ruleType={RuleType.udoconditional}
          isInEditor={isEditor}
          componentTypeRenderer={componentTypeRenderer}
          compName={props?.compName}
        />
      )
    }
  }

  return (
    <div data-testid='react-rule-builder-conditional' id={id}>
      {getConditionals()}
      {getUdoElseBlock()}
    </div>
  )
}

export default RuleBuilderConditional
